import React, { memo } from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icon } from "@iconify/react";

const ProductRow = memo(({
  product,
  orderId,
  masterId,
  quantityView,
  onProductClick,
  onAddQueue,
  onMediaPreview,
  truncateText,
}) => {
  const toNum = (val) => Number(val) || 0;

  const qtyPcs = toNum(product.quantity_in_pieces);
  const partialPcs = toNum(product.partial_dispatch_quantity);
  const completedPcs = toNum(product.total_completed_pieces);
  const totalPcs = qtyPcs + partialPcs;
  const donePcs = completedPcs + partialPcs;
  const percentage = totalPcs ? (donePcs * 100) / totalPcs : 0;

  const qtySqft = toNum(product.quantity_in_soft);
  const completedSqft = toNum(product.total_completed_sqft_pcs) - toNum(product.remaining_production_update_sqft_pcs);
  const remainingSqft = toNum(product.remaining_quantity_in_sqft_pcs);

  const tooltipContent = quantityView === "pcs" ? (
    <>
      Completed: {donePcs} pcs<br />
      {qtyPcs - completedPcs < 0
        ? `Extra: +${Math.abs(qtyPcs - completedPcs)}`
        : `Remaining: ${qtyPcs - completedPcs}`} pcs<br />
      Total: {qtyPcs} pcs
    </>
  ) : (
    <>
      Completed: {completedSqft.toFixed(2)} sqft<br />
      {remainingSqft < 0
        ? `Extra: +${Math.abs(remainingSqft).toFixed(2)}`
        : `Remaining: ${remainingSqft.toFixed(2)}`} sqft<br />
      Total: {qtySqft.toFixed(2)} sqft
    </>
  );

  return (
    <tr>
      <td style={{ cursor: "pointer" }}>
        <div
          title={product.prodName}
          onClick={() => onProductClick(product)}
          className="text-primary text-decoration-underline"
        >
          {product.product_id}
        </div>
        <div
          onClick={() => onAddQueue({ orderId, masterId }, product.product_id, product.queue_ids || [])}
          className="mt-1 d-flex align-items-center"
        >
          <Badge pill bg="primary" className="me-1" style={{ cursor: "pointer" }}>
            Add Queue
          </Badge>
          {product?.partial_dispatch_quantity > 0 && (
            <Badge pill bg="info" className="ms-1">PD</Badge>
          )}
        </div>
      </td>
      <td title={product.design_name}>{product.design_name}</td>
      <td title={product.color_name}>{truncateText(product.color_name)}</td>
      <td>
        {quantityView === "pcs"
          ? Number(product.quantity_in_pieces ?? 0).toFixed(0)
          : Number(product.quantity_in_soft ?? 0).toFixed(2)}
      </td>
      <td>
        <div className="d-flex flex-column gap-1 w-100">
          <OverlayTrigger placement="top" overlay={<Tooltip>{tooltipContent}</Tooltip>}>
            <div className="w-100">
              <div className="progress progress-sm rounded-pill">
                <div
                  className={`progress-bar rounded-pill ${donePcs >= totalPcs ? "bg-success" : "bg-primary-600"}`}
                  style={{ width: `${percentage.toFixed(2)}%` }}
                />
              </div>
            </div>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip>{tooltipContent}</Tooltip>}>
            <span className="text-secondary-light font-xs fw-semibold line-height-1 text-center">
              {percentage.toFixed(0)}%
            </span>
          </OverlayTrigger>
        </div>
      </td>
      <td>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => onMediaPreview(product, orderId)}
        >
          <Icon icon="lucide:image" />
        </button>
      </td>
    </tr>
  );
});

export default ProductRow;